var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.variant === _vm.VARIANT.DETAILED
    ? _c(
        "div",
        { staticClass: "interactive-info--detailed" },
        [
          _c("CompassTooltip", { attrs: { content: _vm.tooltipText } }, [
            _vm.type === _vm.TYPE.EMAIL
              ? _c(
                  "div",
                  {
                    staticClass: "interactive-info__email-button",
                    class: _vm.textClasses,
                    on: { click: _vm.sendEmail }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.getLabel(_vm.values[0])) +
                        "\n        "
                    )
                  ]
                )
              : _c(
                  "a",
                  {
                    class: _vm.textClasses,
                    attrs: { href: _vm.getLink(_vm.values[0]) },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.getLabel(_vm.values[0])) +
                        "\n        "
                    )
                  ]
                )
          ])
        ],
        1
      )
    : _c(
        "div",
        { staticClass: "interactive-info--icons" },
        [
          _vm.type !== _vm.TYPE.EMAIL && _vm.values.length > 1
            ? _c(
                "div",
                [
                  _c(
                    "CompassMenu",
                    {
                      attrs: {
                        customClass: "menu-phone",
                        size: "small",
                        placement: "bottom"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "dropdown",
                            fn: function() {
                              return [
                                _c("CompassMenuSubtitle", {
                                  attrs: { label: _vm.tooltipText }
                                }),
                                _vm._v(" "),
                                _vm._l(_vm.values, function(
                                  phoneNumber,
                                  index
                                ) {
                                  return _c(
                                    "a",
                                    {
                                      key: index,
                                      staticClass:
                                        "typographies-paragraph-small-regular interactive-info--link",
                                      attrs: { href: _vm.getLink(phoneNumber) }
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(_vm.getLabel(phoneNumber)) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                })
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        32795560
                      )
                    },
                    [
                      _c("CompassIconButton", {
                        attrs: { size: _vm.size, icon: "phone" }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.type === _vm.TYPE.EMAIL
            ? _c(
                "CompassTooltip",
                { attrs: { content: _vm.tooltipText } },
                [
                  _c("CompassIconButton", {
                    attrs: { icon: "email", size: _vm.size },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.sendEmail($event)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }